import { createAsyncThunk } from "@reduxjs/toolkit";


import { ThunkAPI } from "../types";

// Load demo review by quote id

import apiCalls from "../../../PowerShadesAPIFunctions";
import { DemoReview } from "../../../powershadesApiTypeExtensions";
import { captureSentryError, extractErrorMessage, isFailedApiCall } from "../../../psUtil";
import { extraEntityReducersFunction } from "../entitiesType";


const loadDemoReview = createAsyncThunk<DemoReview, number, ThunkAPI>(
    'entity/loadDemoReview',
    async (quoteId, { rejectWithValue }) => {
        try {
            const { getDemoReview } = apiCalls;

            const demoReview = await getDemoReview(quoteId);

            if (isFailedApiCall(demoReview)) {
                throw demoReview.error;
            }

            return demoReview.data.demo_review;
        } catch (err: any) {
            captureSentryError(err, {
                tags: {
                    section: 'redux'
                },
                extra: {
                    redux_action: 'loadDemoReview',
                    file_origin: 'src/Store/entities/quoteDemoReviews/index.ts'
                },
            });

            const errorMessage = extractErrorMessage(err);
            return rejectWithValue(errorMessage);
        }
    }
);


const quoteDemoReviewBuilder:extraEntityReducersFunction  = (builder) => {

    builder.addCase(loadDemoReview.fulfilled, (state, action) => {
        const demoReview = action.payload;

        const demoReviewRecord = state.quoteDemoReviews ;

        demoReviewRecord[action.meta.arg] = demoReview;

        state.quoteDemoReviews = demoReviewRecord;
    });
    builder.addCase(loadDemoReview.rejected, (state, action) => {
        
        const demoReviewRecord = state.quoteDemoReviews ;

        demoReviewRecord[action.meta.arg] = {
            name : "None",
            quote_id: action.meta.arg,
            is_shipping_free: false,
            demo_review_status: "none",
            demo_requested_time: 0,
            description: "",
            demo_approval_type_id: 0,
            demo_requested_user_id: 0,
            demo_review_time: 0,
            demo_review_user_id: 0,
            review_description: "",
            id: 0,
            unit_name: "",
        };
    });
    builder.addCase(loadDemoReview.pending, (state, action) => {
        const demoReviewRecord = state.quoteDemoReviews;

        // If the quoteId is not already in the record, initialize it
        if (!demoReviewRecord[action.meta.arg]) {
            demoReviewRecord[action.meta.arg] = {
                name: "None",
                quote_id: action.meta.arg,
                is_shipping_free: false,
                demo_review_status: "none",
                demo_requested_time: 0,
                description: "",
                demo_approval_type_id: 0,
                demo_requested_user_id: 0,
                demo_review_time: 0,
                demo_review_user_id: 0,
                review_description: "",
                id: 0,
                unit_name: "",
            };
        }
    });
}

export {
    loadDemoReview,
    quoteDemoReviewBuilder
};